//
// # NetworkStatusIndicator
//
// A pill-shaped indicator in the title bar that reflects the WebSocket
// connection state to AlphaServer. Passive for now — no click action.
//

import React from "react";
import { useWorkspaceSnapshot } from "../context";

export function NetworkStatusIndicator(): React.ReactElement {
  const { isConnected } = useWorkspaceSnapshot();
  const label = isConnected ? "Connected" : "Disconnected - Error";
  const title = isConnected
    ? "WebSocket connection to AlphaServer is open"
    : "WebSocket connection to AlphaServer is not open";
  return (
    <div
      className="ide-network-status"
      data-connected={isConnected ? "true" : "false"}
      title={title}
    >
      <span className="ide-network-status-dot" />
      <span className="ide-network-status-label">{label}</span>
    </div>
  );
}
